import script from "./CouponList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouponList.vue?vue&type=script&setup=true&lang=ts"

import "./CouponList.vue?vue&type=style&index=0&id=2a74e338&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a74e338"]])

export default __exports__